import React, { useState } from 'react';
import './LoginScreen.css';

const LoginScreen = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showRealLogin, setShowRealLogin] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = onLogin(username, password);
    if (!success) {
      setError('Invalid username or password');
    } else {
      setError('');
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-header">
          <h1>🎬 Movie Collection</h1>
          <p>Track and rate your favorite movies</p>
        </div>
        
        {!showRealLogin ? (
          // Demo Section (Default)
          <div className="demo-section">
            <div className="demo-credentials">
              <h3>🎬 Try the Demo</h3>
              <p>Experience the app with sample movies</p>
              <div className="demo-login-info">
                <div className="credential-item">
                  <span className="credential-label">Username:</span>
                  <span className="credential-value">guest</span>
                </div>
                <div className="credential-item">
                  <span className="credential-label">Password:</span>
                  <span className="credential-value">demo</span>
                </div>
              </div>
              <button 
                className="demo-button"
                onClick={() => {
                  setUsername('guest');
                  setPassword('demo');
                  // Use setTimeout to ensure state is updated before calling handleSubmit
                  setTimeout(() => {
                    const success = onLogin('guest', 'demo');
                    if (!success) {
                      setError('Invalid username or password');
                    } else {
                      setError('');
                    }
                  }, 0);
                }}
              >
                Try Demo Now
              </button>
            </div>
            
            <div className="real-login-toggle">
              <button 
                className="toggle-button"
                onClick={() => setShowRealLogin(true)}
              >
                Owner Login
              </button>
            </div>
          </div>
        ) : (
          // Real Login Section
          <div className="real-login-section">
            <div className="real-login-header">
              <h3>Owner Access</h3>
              <button 
                className="back-to-demo"
                onClick={() => setShowRealLogin(false)}
              >
                ← Back to Demo
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>
              
              {error && <div className="error-message">{error}</div>}
              
              <button type="submit" className="login-button">
                Sign In
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginScreen; 